/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WatchdogId
 */
export interface WatchdogId {
    /**
     * 
     * @type {number}
     * @memberof WatchdogId
     */
    id?: number;
}

/**
 * Check if a given object implements the WatchdogId interface.
 */
export function instanceOfWatchdogId(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WatchdogIdFromJSON(json: any): WatchdogId {
    return WatchdogIdFromJSONTyped(json, false);
}

export function WatchdogIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): WatchdogId {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function WatchdogIdToJSON(value?: WatchdogId | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

